import React from "react";
import {
  Page,
  Navbar,
  NavRight,
  Link,
  Block,
  BlockTitle,
  Card,
  CardContent,
  CardFooter,
  CardHeader,
  List,
  ListInput,
  ListItem,
  ListItemCell,
  Icon,
  Button,
  Row,
  Col,
  Popup,
  Preloader,
  TextEditor,
  Checkbox,
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionToggle,
  Range,
  Segmented,
} from "framework7-react";

import { Doughnut, Line, Bar, Mixed } from "react-chartjs-2";

import { BikeSvg } from "../components/crumbs";

import moment from "moment";
import * as geofire from "geofire-common";

// Redux
import { compose } from "redux";
import { connect } from "react-redux";
import { getDistance } from "geolib";
import { withFirestore, firestoreConnect } from "../HOCs";
import {
  toast,
  handleErrors,
  sendEasychawOneTimePassword,
  verifyEasychawOneTimePassword,
} from "../utils/_helpers";
import {
  Collections,
  FilterByText,
  FilterByNumber,
  FilterBySelect,
} from "../utils/_classes";

class AdminSales extends React.Component {
  constructor(props) {
    super(props);
    const durationYearlyOptions = [];
    let startYear = 2019;
    while(startYear <= Number(moment().format("YYYY"))) {
      durationYearlyOptions.push(startYear);
      startYear++;
    }

    this.state = {
      popupOpened: false,
      popupDataChanged: false,
      popupData: {
        title: "",
        which: "",
      },

      nearestBranches: [],

      //used for range of delivery agents
      deliveryAgentsRange: 15,

      //used for loading delivery agents
      vendorSheetOpened: false,

      // sales single order detail
      salesOrderDetails: null,

      // state for form fields reset
      transactionId: "",
      orderId: "",
      orderStatus: "",
      merchantName: "",
      customerName: "",
      customerPhone: "",
      deliveryAgentName: "",
      deliveryAgentEmail: "",

      // Data state
      orders: [],
      deliveryAgents: [],

      filterBy: {
        dbName: "",
        property: "",
        value: "",
        type: "",
      },

      reportViewer: false,
      sets: 4, // 1 - total, 2 - completed, 3 - declined, 4 - combined
      duration: "4", // 1 - daily, 2 - weekly, 3 - monthly, 4 - yearly
      durationYearly: moment().format("YYYY"),
      durationYearlyOptions,
      /*
        if duration is [1 - daily]:
        then labels should be the orders 
        for the current day eg: labels: ['30 Mar 2021']

        if duration is [2 - weekly]:
        then labels should be the orders 
        from six previous days to current day eg: labels: ['Wed', 'Thu', 'Fri', 'Sat', 'Sun', 'Mon', 'Tue']

        if duration is [3 - monthly]:
        then labels should be the orders 
        from the begining of the current month to the current day of the month eg: labels: ['1', '2', '3', '4', '5', ..., '30']

        if duration is [4 - yearly]:
        then labels should be the orders 
        from the begining of the current year to the current month of the year eg: labels: ['Jan', 'Feb', 'Mar']
      */
      labels: ["Jan", "Feb", "Mar"],
      totalOrders: {
        label: "# Total Orders",
        data: [12, 19, 30],
        backgroundColor: Array([12, 19, 30].length).fill(
          "rgba(135, 206, 235, 0.7)",
        ),
      },
      // pendingOrders: {
      //   label: '# Pending Orders',
      //   data: [12, 19, 30],
      //   backgroundColor: Array([12, 19, 30].length).fill(
      //     'rgba(135, 206, 235, 0.7)'
      //   ),
      // },
      // pendingDeliveryOrders: {
      //   label: '# Orders Pending Delivery',
      //   data: [12, 19, 30],
      //   backgroundColor: Array([12, 19, 30].length).fill(
      //     'rgba(135, 206, 235, 0.7)'
      //   ),
      // },
      // pendingConfirmationOrders: {
      //   label: '# Orders Pending Confirmation',
      //   data: [12, 19, 30],
      //   backgroundColor: Array([12, 19, 30].length).fill(
      //     'rgba(135, 206, 235, 0.7)'
      //   ),
      // },
      completedOrders: {
        label: "# Completed Orders",
        data: [4, 10, 3],
        backgroundColor: Array([4, 10, 3].length).fill(
          "rgba(75, 192, 192, 0.7)",
        ),
      },
      declinedOrders: {
        label: "# Declined Orders",
        data: [8, 9, 27],
        backgroundColor: Array([8, 9, 27].length).fill(
          "rgba(255, 99, 132, 0.7)",
        ),
      },
    };
  }

  
  render() {
    console.log(this.state.duration);
    return (
      <Page>
        <Block>
          <Row>
            {/* All Sales Card */}
            <Col width="100">
              <Card
                className="data-table data-table-init"
                style={{
                  width: "100%",
                  marginLeft: "0px",
                  marginBottom: "40px",
                }}
              >
                <CardHeader>
                  <div className="data-table-title">All Sales</div>
                  <Button
                    outline
                    onClick={() => {
                      this.setState({
                        ...this.state,
                        reportViewer: true,
                      });
                      this.displayYearly();
                      // this.displayWeekly();
                      // this.displayMonthly();
                      // this.displayDaily();
                      this.$f7.methods.scrollTo(this.$f7, "#reportViewer");
                    }}
                  >
                    <Icon f7="chart_bar_square" />
                    &nbsp;&nbsp; Generate Report
                  </Button>
                </CardHeader>
                {this.props.ordered.orders ? (
                  <CardContent
                    padding={false}
                    style={{
                      width: "100%",
                      // maxHeight: '600px',
                      maxHeight:
                        parseInt(window.innerWidth) <= 1400 ? "70vh" : "80vh",
                      paddingBottom: "20px",
                      overflow: "scroll",
                    }}
                  >
                    <table className="sticky">
                      <thead>
                        <tr>
                          <th>
                            <span className="table-head-label">SNo.</span>
                          </th>
                          <th className="input-cell">
                            <span className="table-head-label">Order ID</span>
                            <div className="input">
                              <input
                                type="text"
                                value={this.state.orderId}
                                onChange={(e) =>
                                  this.setState({
                                    ...this.state,
                                    transactionId: "",
                                    orderId: e.target.value,
                                    customerName: "",
                                    customerPhone: "",
                                    orderStatus: "",
                                    merchantName: "",
                                    filterBy: {
                                      dbName: "orders",
                                      property: "id",
                                      value: e.target.value,
                                      type: "text",
                                    },
                                  })
                                }
                                placeholder="Filter"
                              />
                            </div>
                          </th>
                          <th className="input-cell">
                            <span className="table-head-label">
                              Order Status
                            </span>
                            <div className="input">
                              <input
                                type="text"
                                value={this.state.orderStatus}
                                onChange={(e) =>
                                  this.setState({
                                    ...this.state,
                                    transactionId: "",
                                    orderId: "",
                                    orderStatus: e.target.value,
                                    customerName: "",
                                    customerPhone: "",
                                    merchantName: "",
                                    filterBy: {
                                      dbName: "orders",
                                      property: "orderStatus",
                                      value: e.target.value,
                                      type: "text",
                                    },
                                  })
                                }
                                placeholder="Filter"
                              />
                            </div>
                          </th>
                          <th className="input-cell">
                            <span className="table-head-label">
                              Transaction ID
                            </span>
                            <div className="input">
                              <input
                                type="text"
                                value={this.state.transactionId}
                                onChange={(e) =>
                                  this.setState({
                                    ...this.state,
                                    transactionId: e.target.value,
                                    orderId: "",
                                    orderStatus: "",
                                    merchantName: "",
                                    customerName: "",
                                    customerPhone: "",
                                    filterBy: {
                                      dbName: "orders",
                                      property: "reference",
                                      value: e.target.value,
                                      type: "text",
                                    },
                                  })
                                }
                                placeholder="Filter"
                              />
                            </div>
                          </th>
                          <th className="input-cell">
                            <span className="table-head-label">
                              Customer Name
                            </span>
                            <div className="input">
                              <input
                                type="text"
                                value={this.state.customerName}
                                onChange={(e) =>
                                  this.setState({
                                    ...this.state,
                                    transactionId: "",
                                    orderId: "",
                                    orderStatus: "",
                                    merchantName: "",
                                    customerName: e.target.value,
                                    customerPhone: "",
                                    filterBy: {
                                      dbName: "orders",
                                      property: "fullName",
                                      value: e.target.value,
                                      type: "text",
                                    },
                                  })
                                }
                                placeholder="Filter"
                              />
                            </div>
                          </th>
                          <th className="input-cell">
                            <span className="table-head-label">
                              Customer Phone
                            </span>
                            <div className="input">
                              <input
                                type="text"
                                value={this.state.customerPhone}
                                onChange={(e) =>
                                  this.setState({
                                    ...this.state,
                                    transactionId: "",
                                    orderId: "",
                                    orderStatus: "",
                                    merchantName: "",
                                    customerName: "",
                                    customerPhone: e.target.value,
                                    filterBy: {
                                      dbName: "orders",
                                      property: "phoneNumber",
                                      value: e.target.value,
                                      type: "text",
                                    },
                                  })
                                }
                                placeholder="Filter"
                              />
                            </div>
                          </th>
                          <th className="input-cell">
                            <span className="table-head-label">
                              Merchant Name
                            </span>
                            <div className="input">
                              <input
                                type="text"
                                value={this.state.merchantName}
                                onChange={(e) =>
                                  this.setState({
                                    ...this.state,
                                    transactionId: "",
                                    orderId: "",
                                    orderStatus: "",
                                    customerName: "",
                                    customerPhone: "",
                                    merchantName: e.target.value,
                                    filterBy: {
                                      dbName: "orders",
                                      property: "merchantName",
                                      value: e.target.value,
                                      type: "text",
                                    },
                                  })
                                }
                                placeholder="Filter"
                              />
                            </div>
                          </th>
                          <th>
                            <span className="table-head-label">Timestamp</span>
                          </th>
                          <th>
                            <span className="table-head-label">Action</span>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {this.state.orders
                          .sort(
                            (a, b) =>
                              +moment(b.timestamp) - +moment(a.timestamp),
                          )
                          .sort((a, b) => {
                            if (a.orderStatus === "Order Cancelled") {
                              if (b.orderStatus === "Order Completed")
                                return -1;
                              if (
                                b.orderStatus === "Order Pending" ||
                                b.orderStatus === "Order Pending Delivery" ||
                                b.orderStatus === "Order Pending Confirmation"
                              )
                                return 1;
                              return 0;
                            }

                            if (a.orderStatus === "Order Pending Delivery") {
                              if (
                                b.orderStatus === "Order Cancelled" ||
                                b.orderStatus ===
                                  "Order Pending Confirmation" ||
                                b.orderStatus === "Order Completed"
                              )
                                return -1;
                              if (b.orderStatus === "Order Pending") return 1;
                              return 0;
                            }

                            if (
                              a.orderStatus === "Order Pending Confirmation"
                            ) {
                              if (
                                b.orderStatus === "Order Cancelled" ||
                                b.orderStatus === "Order Completed"
                              )
                                return -1;
                              if (
                                b.orderStatus === "Order Pending" ||
                                b.orderStatus === "Order Pending Confirmation"
                              )
                                return 1;
                              return 0;
                            }

                            if (a.orderStatus === "Order Pending") {
                              if (
                                b.orderStatus === "Order Cancelled" ||
                                b.orderStatus === "Order Pending Delivery" ||
                                b.orderStatus ===
                                  "Order Pending Confirmation" ||
                                b.orderStatus === "Order Completed"
                              )
                                return -1;
                              return 0;
                            }

                            if (a.orderStatus === "Order Completed") {
                              if (
                                b.orderStatus === "Order Cancelled" ||
                                b.orderStatus === "Order Pending Delivery" ||
                                b.orderStatus ===
                                  "Order Pending Confirmation" ||
                                b.orderStatus === "Order Pending"
                              )
                                return 1;
                              return 0;
                            }
                          })
                          .map((order, i) => (
                            <tr key={order.id}>
                              <td
                                className={
                                  order.orderStatus == "Order Pending"
                                    ? "signal-pending"
                                    : order.orderStatus == "Order Completed"
                                    ? "signal-complete"
                                    : order.orderStatus == "Order Cancelled"
                                    ? "signal-cancelled"
                                    : "signal-default"
                                }
                              >
                                <div>{i + 1}</div>
                              </td>
                              <td>
                                <div>{order.id}</div>
                              </td>
                              <td>
                                <div>{order.orderStatus}</div>
                              </td>
                              <td>
                                <div>{order.reference}</div>
                              </td>
                              <td>
                                <div>{order.fullName}</div>
                              </td>
                              <td>
                                <div>{order.phoneNumber}</div>
                              </td>
                              <td>
                                <div>{order.merchantName}</div>
                              </td>

                              <td>
                                <div>{moment(order.timestamp).fromNow()}</div>
                              </td>
                              <td>
                                <Button
                                  fill
                                  onClick={() => {
                                    this.setState({
                                      ...this.state,
                                      popupOpened: true,
                                      popupDataChanged: true,
                                      popupData: {
                                        title: "Sale Order",
                                        which: "sales",
                                      },
                                      salesOrderDetails: order,
                                    });
                                  }}
                                >
                                  Details
                                </Button>
                              </td>
                            </tr>
                          ))}
                      </tbody>
                    </table>
                  </CardContent>
                ) : (
                  <CardContent padding={false}>
                    <Block className="block-info">
                      <Row>
                        <Col>
                          <p>No sales transactions available at the moment!</p>
                        </Col>
                      </Row>
                    </Block>
                  </CardContent>
                )}
              </Card>
            </Col>

            {/* Sales Chart*/}
            {this.state.reportViewer && (
              <Col width="100" id="reportViewer">
                {parseInt(window.innerWidth) > 768 ? (
                  <Card
                    className="data-table data-table-init"
                    style={{
                      width: "100%",
                      marginLeft: "0px",
                      marginBottom: "40px",
                    }}
                  >
                    <CardHeader>
                      <List
                        style={{ width: "200px", backgroundColor: "#fafafa" }}
                      >
                        <ListItem
                          title="Sales Report"
                          smartSelect
                          smartSelectParams={{
                            openIn: "popover",
                            closeOnSelect: true,
                          }}
                        >
                          <select
                            name="duration"
                            defaultValue={this.state.duration}
                            onChange={this.switchDuration.bind(this)}
                          >
                            <option value="1">Daily</option>
                            <option value="2">Weekly</option>
                            <option value="3">Monthly</option>
                            <option value="4">Yearly</option>
                            <option value="5">All Years</option>
                          </select>
                        </ListItem>
                          {
                            this.state.duration === "4" ? (
                              <ListItem
                              title="Choose Year"
                              smartSelect
                              smartSelectParams={{
                                openIn: "popover",
                                closeOnSelect: true,
                              }}
                            >
                              <select
                                name="durationYearly"
                                defaultValue={this.state.durationYearly}
                                onChange={this.switchDurationYearly.bind(this)}
                              >
                                {
                                  this.state.durationYearlyOptions.map(op => (
                                      <option value={op} key={op}>{op}</option>
                                  ))
                                }
                              </select>
                            </ListItem>
                            ) : null
                          }
                       
                      </List>
                      <Button
                        outline
                        onClick={() => {
                          this.setState({
                            ...this.state,
                            reportViewer: false,
                          });
                        }}
                      >
                        <Icon f7="chart_bar_square" />
                        &nbsp;&nbsp; Hide Report
                      </Button>
                    </CardHeader>
                    <CardContent>
                      <Block className="bg-color-cultured">
                        <Bar
                          data={{
                            labels: this.state.labels,
                            datasets: this.datasetsSelector(this.state.sets),
                          }}
                        />
                      </Block>
                    </CardContent>
                    <CardFooter>
                      <Segmented strong tag="p" style={{ width: "100%" }}>
                        <Button
                          active={this.state.sets == 1}
                          onClick={() =>
                            this.setState({ ...this.state, sets: 1 })
                          }
                        >
                          Total Orders
                        </Button>
                        <Button
                          active={this.state.sets == 2}
                          onClick={() =>
                            this.setState({ ...this.state, sets: 2 })
                          }
                        >
                          Completed Orders
                        </Button>
                        <Button
                          active={this.state.sets == 3}
                          onClick={() =>
                            this.setState({ ...this.state, sets: 3 })
                          }
                        >
                          Declined Orders
                        </Button>
                        {/* <Button
                          active={this.state.sets == 4}
                          onClick={() =>
                            this.setState({ ...this.state, sets: 4 })
                          }>
                          Pending Orders
                        </Button>
                        <Button
                          active={this.state.sets == 5}
                          onClick={() =>
                            this.setState({ ...this.state, sets: 5 })
                          }>
                          Pending Delivery Orders
                        </Button>
                        <Button
                          active={this.state.sets == 6}
                          onClick={() =>
                            this.setState({ ...this.state, sets: 6 })
                          }>
                          Pending Confirmation Orders
                        </Button> */}
                        <Button
                          active={this.state.sets == 4}
                          onClick={() =>
                            this.setState({ ...this.state, sets: 4 })
                          }
                        >
                          Combine Chart
                        </Button>
                      </Segmented>
                    </CardFooter>
                  </Card>
                ) : (
                  <Card
                    style={{
                      width: "100%",
                      marginLeft: "0px",
                      marginBottom: "40px",
                    }}
                  >
                    <CardHeader style={{ backgroundColor: "orange" }}>
                      Warning
                      <Button
                        color="orange"
                        onClick={() => {
                          this.setState({
                            ...this.state,
                            reportViewer: false,
                          });
                        }}
                      >
                        <Icon f7="clear_fill" />
                      </Button>
                    </CardHeader>
                    <CardContent>
                      <Block
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          flexDirection: "column",
                        }}
                      >
                        <Icon
                          f7="exclamationmark_triangle_fill"
                          style={{
                            color: "orange",
                            marginTop: "30px",
                            fontSize: "50px",
                          }}
                        />
                        <h5>Please view report on desktop/laptop.</h5>
                      </Block>
                    </CardContent>
                  </Card>
                )}
              </Col>
            )}
          </Row>
        </Block>

        <Popup
          swipeToClose="to-bottom"
          className="easychaw-popup"
          opened={this.state.popupOpened}
          onPopupClosed={() =>
            this.setState({
              ...this.state,
              popupOpened: false,
              popupDataChanged: false,
              popupData: { title: "", which: "" },
              vendor: null,
              nearestBranches: [],
              vendorSheetOpened: false,
              deliveryAgentName: "",
              deliveryAgentEmail: "",
            })
          }
          onPopupOpened={(e) => e.app.methods.showFullText()}
        >
          <Page>
            <Navbar title={this.state.popupData.title}>
              <NavRight>
                <Link popupClose>Close</Link>
              </NavRight>
            </Navbar>

            {/* Content for viewing sale order */}
            {this.state.popupData.which == "sales" ? (
              <Block style={{ margin: "auto" }}>
                {/* [Card-1] Order Items */}
                <Card style={{ margin: "auto", marginTop: "10pt" }}>
                  <CardHeader
                    className={`
                      no-border
                      bg-image-pattern no-padding
                      ${
                        this.props.data.orders[this.state.salesOrderDetails.id]
                          .orderStatus === "Order Pending"
                          ? "bg-color-bisque"
                          : this.props.data.orders[
                              this.state.salesOrderDetails.id
                            ].orderStatus === "Order Pending Confirmation"
                          ? "bg-color-oldlace"
                          : this.props.data.orders[
                              this.state.salesOrderDetails.id
                            ].orderStatus === "Order Completed"
                          ? "bg-color-teagreen"
                          : this.props.data.orders[
                              this.state.salesOrderDetails.id
                            ].orderStatus === "Order Pending Delivery"
                          ? "bg-color-cultured"
                          : "bg-color-pink"
                      }
                    `}
                    style={{
                      backgroundSize:
                        parseInt(window.innerWidth) < 700 ? "50%" : "30%",
                      height: "200px",
                    }}
                  >
                    {this.props.data.orders[this.state.salesOrderDetails.id]
                      .orderStatus === "Order Pending Confirmation" ? (
                      <BikeSvg height="200px" style={{ margin: "auto" }} />
                    ) : this.props.data.orders[this.state.salesOrderDetails.id]
                        .orderStatus === "Order Completed" ? (
                      <img
                        src="static/confirmed.svg"
                        style={{ margin: "auto", width: "200px" }}
                      />
                    ) : this.props.data.orders[this.state.salesOrderDetails.id]
                        .orderStatus === "Order Pending" ? (
                      <img
                        src="static/relax.svg"
                        style={{ margin: "auto", width: "200px" }}
                      />
                    ) : this.props.data.orders[this.state.salesOrderDetails.id]
                        .orderStatus === "Order Pending Delivery" ? (
                      <img
                        src="static/delivery.svg"
                        style={{ margin: "auto", width: "200px" }}
                      />
                    ) : (
                      <img
                        src="static/cancel.svg"
                        style={{ margin: "auto", width: "200px" }}
                      />
                    )}
                  </CardHeader>
                  <CardFooter>
                    <strong
                      className={`
                        ${
                          this.props.data.orders[
                            this.state.salesOrderDetails.id
                          ].orderStatus === "Order Pending Confirmation" ||
                          this.props.data.orders[
                            this.state.salesOrderDetails.id
                          ].orderStatus === "Order Pending Delivery"
                            ? "color-bluejeans"
                            : this.props.data.orders[
                                this.state.salesOrderDetails.id
                              ].orderStatus === "Order Completed"
                            ? "color-forestgreen"
                            : this.props.data.orders[
                                this.state.salesOrderDetails.id
                              ].orderStatus === "Order Pending"
                            ? "color-yelloworange"
                            : "color-tart"
                        }
                      `}
                    >
                      {this.props.data.orders[this.state.salesOrderDetails.id]
                        .orderStatus === "Order Cancelled"
                        ? "Declined"
                        : true === "Order Pending Confirmation"
                        ? "Enroute"
                        : this.props.data.orders[
                            this.state.salesOrderDetails.id
                          ].orderStatus}
                    </strong>
                    <Button
                      outline
                      iconF7="doc_on_clipboard"
                      onClick={(e) => this.$f7.methods.copyText(e, "Order Id")}
                    >
                      &nbsp;&nbsp;&nbsp;Order Id:
                      <span className="copytext">
                        {this.state.salesOrderDetails.id}
                      </span>
                    </Button>
                  </CardFooter>
                </Card>

                {/* If admin initiated action */}
                {this.props.data.orders[this.state.salesOrderDetails.id]
                  .confirmedByAdminOrSupport ? (
                  <Card style={{ margin: "10pt auto" }}>
                    <CardHeader className="no-border">
                      Order was confirmed by an Admin/Staff
                    </CardHeader>

                    <CardContent>
                      <List>
                        <ListItem className="show-text">
                          <span slot="title">
                            {
                              this.props.data.orders[
                                this.state.salesOrderDetails.id
                              ].confirmedByAdminOrSupport.name
                            }
                          </span>
                          <small slot="after">
                            {this.props.data.orders[
                              this.state.salesOrderDetails.id
                            ].confirmedByAdminOrSupport.role
                              ? this.props.data.orders[
                                  this.state.salesOrderDetails.id
                                ].confirmedByAdminOrSupport.role === "Admin"
                                ? this.props.data.orders[
                                    this.state.salesOrderDetails.id
                                  ].confirmedByAdminOrSupport.role + " Name"
                                : "Staff Name"
                              : "Name"}
                          </small>
                          <Icon f7="person_fill" slot="media" />
                        </ListItem>
                        {this.props.data.orders[this.state.salesOrderDetails.id]
                          .confirmedByAdminOrSupport.email && (
                          <ListItem className="show-text" after="Email Address">
                            <span slot="title">
                              {
                                this.props.data.orders[
                                  this.state.salesOrderDetails.id
                                ].confirmedByAdminOrSupport.email
                              }
                            </span>
                            <Icon f7="envelope" slot="media" />
                          </ListItem>
                        )}
                        {this.props.data.orders[this.state.salesOrderDetails.id]
                          .confirmedByAdminOrSupport.phone && (
                          <ListItem className="show-text" after="Phone Number">
                            <span slot="title">
                              {
                                this.props.data.orders[
                                  this.state.salesOrderDetails.id
                                ].confirmedByAdminOrSupport.phone
                              }
                            </span>
                            <Icon f7="phone_fill_arrow_up_right" slot="media" />
                          </ListItem>
                        )}

                        {this.props.data.orders[this.state.salesOrderDetails.id]
                          .confirmedByAdminOrSupport.timestamp && (
                          <ListItem className="show-text" after="Date">
                            <span slot="title">
                              {moment(
                                this.props.data.orders[
                                  this.state.salesOrderDetails.id
                                ].confirmedByAdminOrSupport.timestamp,
                              ).format("dddd, MMMM Do YYYY, h:mm:ss a")}
                            </span>
                            <Icon f7="calendar" slot="media" />
                          </ListItem>
                        )}
                      </List>
                    </CardContent>

                    <CardFooter>
                      {this.props.data.orders[this.state.salesOrderDetails.id]
                        .confirmedByAdminOrSupport.phone && (
                        <Button
                          outline
                          style={{ width: "45%" }}
                          href={`tel://${
                            this.props.data.orders[
                              this.state.salesOrderDetails.id
                            ].confirmedByAdminOrSupport.phone
                          }`}
                          external
                          onClick={() =>
                            this.$f7.methods.phoneCall(
                              this.props.data.orders[
                                this.state.salesOrderDetails.id
                              ].confirmedByAdminOrSupport.phone,
                            )
                          }
                        >
                          <Icon f7="phone_fill_arrow_up_right" />
                          &nbsp;&nbsp;&nbsp;Call Admin
                        </Button>
                      )}

                      <Button
                        outline
                        style={{ width: "45%" }}
                        onClick={() => this.$f7.methods.navMessage()}
                      >
                        <Icon f7="bubble_left_bubble_right" />
                        &nbsp;&nbsp;&nbsp;Chaw Message&#8482;
                      </Button>
                    </CardFooter>
                  </Card>
                ) : null}

                {this.props.data.orders[this.state.salesOrderDetails.id]
                  .assignedByAdminOrSupport ? (
                  <Card style={{ margin: "10pt auto" }}>
                    <CardHeader className="no-border">
                      Delivery agent was assigned by an Admin/Staff
                    </CardHeader>

                    <CardContent>
                      <List>
                        <ListItem className="show-text">
                          <span slot="title">
                            {
                              this.props.data.orders[
                                this.state.salesOrderDetails.id
                              ].assignedByAdminOrSupport.name
                            }
                          </span>
                          <small slot="after">
                            {this.props.data.orders[
                              this.state.salesOrderDetails.id
                            ].assignedByAdminOrSupport.role
                              ? this.props.data.orders[
                                  this.state.salesOrderDetails.id
                                ].assignedByAdminOrSupport.role === "Admin"
                                ? this.props.data.orders[
                                    this.state.salesOrderDetails.id
                                  ].assignedByAdminOrSupport.role + " Name"
                                : "Staff Name"
                              : "Name"}
                          </small>
                          <Icon f7="person_fill" slot="media" />
                        </ListItem>
                        {this.props.data.orders[this.state.salesOrderDetails.id]
                          .assignedByAdminOrSupport.email && (
                          <ListItem className="show-text" after="Email Address">
                            <span slot="title">
                              {
                                this.props.data.orders[
                                  this.state.salesOrderDetails.id
                                ].assignedByAdminOrSupport.email
                              }
                            </span>
                            <Icon f7="envelope" slot="media" />
                          </ListItem>
                        )}
                        {this.props.data.orders[this.state.salesOrderDetails.id]
                          .assignedByAdminOrSupport.phone && (
                          <ListItem className="show-text" after="Phone Number">
                            <span slot="title">
                              {
                                this.props.data.orders[
                                  this.state.salesOrderDetails.id
                                ].assignedByAdminOrSupport.phone
                              }
                            </span>
                            <Icon f7="phone_fill_arrow_up_right" slot="media" />
                          </ListItem>
                        )}
                        {this.props.data.orders[this.state.salesOrderDetails.id]
                          .assignedByAdminOrSupport.timestamp && (
                          <ListItem className="show-text" after="Date">
                            <span slot="title">
                              {moment(
                                this.props.data.orders[
                                  this.state.salesOrderDetails.id
                                ].assignedByAdminOrSupport.timestamp,
                              ).format("dddd, MMMM Do YYYY, h:mm:ss a")}
                            </span>
                            <Icon f7="calendar" slot="media" />
                          </ListItem>
                        )}
                      </List>
                    </CardContent>

                    <CardFooter>
                      {this.props.data.orders[this.state.salesOrderDetails.id]
                        .assignedByAdminOrSupport.phone && (
                        <Button
                          outline
                          style={{ width: "45%" }}
                          href={`tel://${
                            this.props.data.orders[
                              this.state.salesOrderDetails.id
                            ].assignedByAdminOrSupport.phone
                          }`}
                          external
                          onClick={() =>
                            this.$f7.methods.phoneCall(
                              this.props.data.orders[
                                this.state.salesOrderDetails.id
                              ].assignedByAdminOrSupport.phone,
                            )
                          }
                        >
                          <Icon f7="phone_fill_arrow_up_right" />
                          &nbsp;&nbsp;&nbsp;Call Admin
                        </Button>
                      )}

                      <Button
                        outline
                        style={{ width: "45%" }}
                        onClick={() => this.$f7.methods.navMessage()}
                      >
                        <Icon f7="bubble_left_bubble_right" />
                        &nbsp;&nbsp;&nbsp;Chaw Message&#8482;
                      </Button>
                    </CardFooter>
                  </Card>
                ) : null}

                {this.props.data.orders[this.state.salesOrderDetails.id]
                  .cancelledByAdminOrSupport ? (
                  <Card style={{ margin: "10pt auto" }}>
                    <CardHeader className="no-border">
                      Order was cancelled by an Admin/Staff
                    </CardHeader>

                    <CardContent>
                      <List>
                        <ListItem className="show-text">
                          <span slot="title">
                            {
                              this.props.data.orders[
                                this.state.salesOrderDetails.id
                              ].cancelledByAdminOrSupport.name
                            }
                          </span>
                          <small slot="after">
                            {this.props.data.orders[
                              this.state.salesOrderDetails.id
                            ].cancelledByAdminOrSupport.role
                              ? this.props.data.orders[
                                  this.state.salesOrderDetails.id
                                ].cancelledByAdminOrSupport.role === "Admin"
                                ? this.props.data.orders[
                                    this.state.salesOrderDetails.id
                                  ].cancelledByAdminOrSupport.role + " Name"
                                : "Staff Name"
                              : "Name"}
                          </small>
                          <Icon f7="person_fill" slot="media" />
                        </ListItem>
                        {this.props.data.orders[this.state.salesOrderDetails.id]
                          .cancelledByAdminOrSupport.email && (
                          <ListItem className="show-text" after="Email Address">
                            <span slot="title">
                              {
                                this.props.data.orders[
                                  this.state.salesOrderDetails.id
                                ].cancelledByAdminOrSupport.email
                              }
                            </span>
                            <Icon f7="envelope" slot="media" />
                          </ListItem>
                        )}
                        {this.props.data.orders[this.state.salesOrderDetails.id]
                          .cancelledByAdminOrSupport.phone && (
                          <ListItem className="show-text" after="Phone Number">
                            <span slot="title">
                              {
                                this.props.data.orders[
                                  this.state.salesOrderDetails.id
                                ].cancelledByAdminOrSupport.phone
                              }
                            </span>
                            <Icon f7="phone_fill_arrow_up_right" slot="media" />
                          </ListItem>
                        )}
                        {this.props.data.orders[this.state.salesOrderDetails.id]
                          .cancelledByAdminOrSupport.timestamp && (
                          <ListItem className="show-text" after="Date">
                            <span slot="title">
                              {moment(
                                this.props.data.orders[
                                  this.state.salesOrderDetails.id
                                ].cancelledByAdminOrSupport.timestamp,
                              ).format("dddd, MMMM Do YYYY, h:mm:ss a")}
                            </span>
                            <Icon f7="calendar" slot="media" />
                          </ListItem>
                        )}
                      </List>
                    </CardContent>

                    <CardFooter>
                      {this.props.data.orders[this.state.salesOrderDetails.id]
                        .cancelledByAdminOrSupport.phone && (
                        <Button
                          outline
                          style={{ width: "45%" }}
                          href={`tel://${
                            this.props.data.orders[
                              this.state.salesOrderDetails.id
                            ].cancelledByAdminOrSupport.phone
                          }`}
                          external
                          onClick={() =>
                            this.$f7.methods.phoneCall(
                              this.props.data.orders[
                                this.state.salesOrderDetails.id
                              ].cancelledByAdminOrSupport.phone,
                            )
                          }
                        >
                          <Icon f7="phone_fill_arrow_up_right" />
                          &nbsp;&nbsp;&nbsp;Call Admin
                        </Button>
                      )}

                      <Button
                        outline
                        style={{ width: "45%" }}
                        onClick={() => this.$f7.methods.navMessage()}
                      >
                        <Icon f7="bubble_left_bubble_right" />
                        &nbsp;&nbsp;&nbsp;Chaw Message&#8482;
                      </Button>
                    </CardFooter>
                  </Card>
                ) : null}

                {this.props.data.orders[this.state.salesOrderDetails.id]
                  .deliveryDeclinedByAdminOrSupport ? (
                  <Card style={{ margin: "10pt auto" }}>
                    <CardHeader className="no-border">
                      Order was previously declined for delivery agent{" "}
                      {
                        this.props.data.orders[this.state.salesOrderDetails.id]
                          .deliveryDeclinedByAdminOrSupport.deliveryAgentName
                      }
                      by an Admin/Staff
                    </CardHeader>

                    <CardContent>
                      <List>
                        <ListItem className="show-text">
                          <span slot="title">
                            {
                              this.props.data.orders[
                                this.state.salesOrderDetails.id
                              ].deliveryDeclinedByAdminOrSupport.name
                            }
                          </span>

                          <small slot="after">
                            {this.props.data.orders[
                              this.state.salesOrderDetails.id
                            ].deliveryDeclinedByAdminOrSupport.role
                              ? this.props.data.orders[
                                  this.state.salesOrderDetails.id
                                ].deliveryDeclinedByAdminOrSupport.role ===
                                "Admin"
                                ? this.props.data.orders[
                                    this.state.salesOrderDetails.id
                                  ].deliveryDeclinedByAdminOrSupport.role +
                                  " Name"
                                : "Staff Name"
                              : "Name"}
                          </small>
                          <Icon f7="person_fill" slot="media" />
                        </ListItem>
                        {this.props.data.orders[this.state.salesOrderDetails.id]
                          .deliveryDeclinedByAdminOrSupport.email && (
                          <ListItem className="show-text" after="Email Address">
                            <span slot="title">
                              {
                                this.props.data.orders[
                                  this.state.salesOrderDetails.id
                                ].deliveryDeclinedByAdminOrSupport.email
                              }
                            </span>
                            <Icon f7="envelope" slot="media" />
                          </ListItem>
                        )}
                        {this.props.data.orders[this.state.salesOrderDetails.id]
                          .deliveryDeclinedByAdminOrSupport.phone && (
                          <ListItem className="show-text" after="Phone Number">
                            <span slot="title">
                              {
                                this.props.data.orders[
                                  this.state.salesOrderDetails.id
                                ].deliveryDeclinedByAdminOrSupport.phone
                              }
                            </span>
                            <Icon f7="phone_fill_arrow_up_right" slot="media" />
                          </ListItem>
                        )}
                        {this.props.data.orders[this.state.salesOrderDetails.id]
                          .deliveryDeclinedByAdminOrSupport.timestamp && (
                          <ListItem className="show-text" after="Date">
                            <span slot="title">
                              {moment(
                                this.props.data.orders[
                                  this.state.salesOrderDetails.id
                                ].deliveryDeclinedByAdminOrSupport.timestamp,
                              ).format("dddd, MMMM Do YYYY, h:mm:ss a")}
                            </span>
                            <Icon f7="calendar" slot="media" />
                          </ListItem>
                        )}
                      </List>
                    </CardContent>

                    <CardFooter>
                      {this.props.data.orders[this.state.salesOrderDetails.id]
                        .deliveryDeclinedByAdminOrSupport.phone && (
                        <Button
                          outline
                          style={{ width: "45%" }}
                          href={`tel://${
                            this.props.data.orders[
                              this.state.salesOrderDetails.id
                            ].deliveryDeclinedByAdminOrSupport.phone
                          }`}
                          external
                          onClick={() =>
                            this.$f7.methods.phoneCall(
                              this.props.data.orders[
                                this.state.salesOrderDetails.id
                              ].deliveryDeclinedByAdminOrSupport.phone,
                            )
                          }
                        >
                          <Icon f7="phone_fill_arrow_up_right" />
                          &nbsp;&nbsp;&nbsp;Call Admin
                        </Button>
                      )}

                      <Button
                        outline
                        style={{ width: "45%" }}
                        onClick={() => this.$f7.methods.navMessage()}
                      >
                        <Icon f7="bubble_left_bubble_right" />
                        &nbsp;&nbsp;&nbsp;Chaw Message&#8482;
                      </Button>
                    </CardFooter>
                  </Card>
                ) : null}

                <Card style={{ margin: "auto", marginTop: "10pt" }}>
                  <CardHeader>Order Items</CardHeader>
                  <CardContent>
                    <List>
                      {/* Load packages */}
                      {this.props.data.orders[
                        this.state.salesOrderDetails.id
                      ].packages.map((product, i) => (
                        <ListItem key={i}>
                          <ListItemCell className="width-auto flex-shrink-0">
                            <span style={{ display: "inline-flex" }}>
                              {product.count} &nbsp;x&nbsp;&nbsp;
                            </span>
                          </ListItemCell>
                          <ListItemCell
                            className="flex-shrink-3"
                            style={{ marginLeft: 0 }}
                          >
                            <div className="row">
                              <p className="col">{product.name}</p>
                            </div>
                          </ListItemCell>
                          <ListItemCell className="width-auto flex-shrink-0">
                            <h6>
                              {new Intl.NumberFormat("en-GB", {
                                style: "currency",
                                currency: "NGN",
                              }).format(product.amount)}
                            </h6>
                          </ListItemCell>
                        </ListItem>
                      ))}
                    </List>

                    <List>
                      <ListItem>
                        <ListItemCell
                          className="flex-shrink-3"
                          style={{ marginLeft: 0 }}
                        >
                          <div className="row">
                            <p className="col">
                              {this.props.data.orders[
                                this.state.salesOrderDetails.id
                              ].userDeliveryCharge > 0
                                ? "Delivery Charge"
                                : "Pickup Charge"}
                            </p>
                          </div>
                        </ListItemCell>
                        <ListItemCell className="width-auto flex-shrink-0">
                          <h6>
                            {new Intl.NumberFormat("en-GB", {
                              style: "currency",
                              currency: "NGN",
                            }).format(
                              this.props.data.orders[
                                this.state.salesOrderDetails.id
                              ].userDeliveryCharge,
                            )}
                          </h6>
                        </ListItemCell>
                      </ListItem>
                    </List>
                  </CardContent>
                  <CardFooter>
                    <Button
                      outline
                      iconF7="doc_on_clipboard"
                      onClick={(e) =>
                        this.$f7.methods.copyText(e, "Confirmation Code")
                      }
                    >
                      &nbsp;&nbsp;&nbsp;Confirmation Code:
                      <span className="copytext">
                        {
                          this.props.data.orders[
                            this.state.salesOrderDetails.id
                          ].confirmationCode
                        }
                      </span>
                    </Button>

                    <Button outline disabled>
                      {new Intl.NumberFormat("en-GB", {
                        style: "currency",
                        currency: "NGN",
                      }).format(
                        parseInt(
                          this.props.data.orders[
                            this.state.salesOrderDetails.id
                          ].totalUserAmount,
                        ) +
                          parseInt(
                            this.props.data.orders[
                              this.state.salesOrderDetails.id
                            ].userDeliveryCharge,
                          ),
                      )}
                    </Button>
                  </CardFooter>
                </Card>

                {/* [Card-2] User Details */}
                <Card style={{ margin: "10pt auto" }}>
                  <CardHeader className="no-border">User Details</CardHeader>

                  <CardContent>
                    <List>
                      <ListItem className="show-text" after="Client Name">
                        <span slot="title">
                          {
                            this.props.data.orders[
                              this.state.salesOrderDetails.id
                            ].fullName
                          }
                        </span>
                        <Icon f7="person_fill" slot="media" />
                      </ListItem>
                      <ListItem className="show-text" after="Client Address">
                        <span slot="title">
                          {
                            this.props.data.orders[
                              this.state.salesOrderDetails.id
                            ].deliveryAddress
                          }
                        </span>
                        <Icon f7="placemark_fill" slot="media" />
                      </ListItem>
                      <ListItem after="Client Phone">
                        <span slot="title">
                          {
                            this.props.data.orders[
                              this.state.salesOrderDetails.id
                            ].phoneNumber
                          }
                        </span>
                        <Icon f7="phone_fill_arrow_up_right" slot="media" />
                      </ListItem>
                    </List>
                  </CardContent>

                  <CardFooter>
                    <Button
                      outline
                      style={{ width: "45%" }}
                      href={`tel://${
                        this.props.data.orders[this.state.salesOrderDetails.id]
                          .phoneNumber
                      }`}
                      external
                      onClick={() =>
                        this.$f7.methods.phoneCall(
                          this.props.data.orders[
                            this.state.salesOrderDetails.id
                          ].phoneNumber,
                        )
                      }
                    >
                      <Icon f7="phone_fill_arrow_up_right" />
                      &nbsp;&nbsp;&nbsp;Call User
                    </Button>

                    <Button
                      outline
                      style={{ width: "45%" }}
                      onClick={() => this.$f7.methods.navMessage()}
                    >
                      <Icon f7="bubble_left_bubble_right" />
                      &nbsp;&nbsp;&nbsp;Chaw Message&#8482;
                    </Button>
                  </CardFooter>
                </Card>

                {/* [Card-3] Post Dated Details */}
                <Card style={{ margin: "10pt auto" }}>
                  <CardHeader className="no-border">
                    Post Dated Details
                  </CardHeader>
                  {this.props.data.orders[this.state.salesOrderDetails.id]
                    .postDatedDate ? (
                    <CardContent>
                      <List>
                        <ListItem after="Date | Time">
                          <span slot="title">
                            {this.props.data.orders[
                              this.state.salesOrderDetails.id
                            ].postDatedDate
                              ? moment(
                                  this.props.data.orders[
                                    this.state.salesOrderDetails.id
                                  ].postDatedDate,
                                ).format("dddd, MMMM Do, YYYY | hh:mm")
                              : ""}
                          </span>
                          <Icon f7="info_circle_fill" slot="media" />
                        </ListItem>

                        <ListItem className="show-text" after="Instructions">
                          <span slot="title">
                            {this.props.data.orders[
                              this.state.salesOrderDetails.id
                            ].postDatedInstructions
                              ? this.state.salesOrderDetails
                                  .postDatedInstructions
                              : ""}
                          </span>
                          <Icon f7="info_circle_fill" slot="media" />
                        </ListItem>
                      </List>
                    </CardContent>
                  ) : (
                    <CardContent style={{ paddingTop: 0 }}>
                      <Block className="block-info">
                        <Row>
                          <Col>
                            <p>No Post Dated Order Details</p>
                          </Col>
                        </Row>
                      </Block>
                    </CardContent>
                  )}
                </Card>

                {/* [Card-4] Merchant Details */}
                <Card style={{ margin: "10pt auto" }}>
                  <CardHeader className="no-border">
                    Merchant Details
                  </CardHeader>
                  <CardContent>
                    <List>
                      <ListItem className="show-text" after="Merchant Name">
                        <span slot="title">
                          {
                            this.props.data.orders[
                              this.state.salesOrderDetails.id
                            ].merchantName
                          }
                        </span>
                        <Icon f7="briefcase" slot="media" />
                      </ListItem>
                      <ListItem className="show-text" after="Merchant Address">
                        <span slot="title">
                          {
                            this.props.ordered.merchants.find(
                              ({ id }) =>
                                id ===
                                this.props.data.orders[
                                  this.state.salesOrderDetails.id
                                ].merchantId,
                            ).businessProfile.address
                          }
                        </span>
                        <Icon f7="placemark_fill" slot="media" />
                      </ListItem>
                      <ListItem after="Merchant Phone">
                        <span slot="title">
                          {
                            this.props.data.merchants[
                              this.state.salesOrderDetails.merchantId
                            ].businessProfile.phone
                          }
                        </span>
                        <Icon f7="phone_fill_arrow_up_right" slot="media" />
                      </ListItem>
                    </List>
                  </CardContent>
                  <CardFooter>
                    <Button
                      outline
                      style={{ width: "45%" }}
                      href={`tel://${
                        this.props.data.merchants[
                          this.state.salesOrderDetails.merchantId
                        ].businessProfile.phone
                      }`}
                      external
                      onClick={() =>
                        this.$f7.methods.phoneCall(
                          this.props.data.merchants[
                            this.state.salesOrderDetails.merchantId
                          ].businessProfile.phone,
                        )
                      }
                    >
                      <Icon f7="phone_fill_arrow_up_right" />
                      &nbsp;&nbsp;&nbsp;Call Merchant
                    </Button>

                    <Button
                      outline
                      style={{ width: "45%" }}
                      onClick={() => this.$f7.methods.navMessage()}
                    >
                      <Icon f7="bubble_left_bubble_right" />
                      &nbsp;&nbsp;&nbsp;Chaw Message&#8482;
                    </Button>
                  </CardFooter>
                </Card>

                {/* [Card-5] Delivery Agent/Pickup Details */}
                <Card style={{ margin: "10pt auto" }}>
                  {this.props.data.orders[this.state.salesOrderDetails.id]
                    .deliveryRequired ? (
                    <>
                      <CardHeader className="no-border">
                        Assigned Delivery Agent
                      </CardHeader>

                      {this.props.data.orders[this.state.salesOrderDetails.id]
                        .assignedAgentId &&
                      this.props.data.orders[this.state.salesOrderDetails.id]
                        .assignedAgentId !== "" ? (
                        <>
                          <CardContent>
                            <List>
                              <ListItem
                                className="show-text"
                                after="Agent Name"
                              >
                                <span slot="title">
                                  {
                                    this.props.data.delivery[
                                      this.props.data.orders[
                                        this.state.salesOrderDetails.id
                                      ].assignedAgentId
                                    ].businessProfile.name
                                  }
                                </span>
                                <Icon f7="briefcase" slot="media" />
                              </ListItem>
                              <ListItem
                                className="show-text"
                                after="Agent Address"
                              >
                                <span slot="title">
                                  {
                                    this.props.data.delivery[
                                      this.props.data.orders[
                                        this.state.salesOrderDetails.id
                                      ].assignedAgentId
                                    ].businessProfile.address
                                  }
                                </span>
                                <Icon f7="placemark_fill" slot="media" />
                              </ListItem>
                              <ListItem after="Agent Phone">
                                <span slot="title">
                                  {
                                    this.props.data.delivery[
                                      this.props.data.orders[
                                        this.state.salesOrderDetails.id
                                      ].assignedAgentId
                                    ].businessProfile.phone
                                  }
                                </span>
                                <Icon
                                  f7="phone_fill_arrow_up_right"
                                  slot="media"
                                />
                              </ListItem>

                              {this.props.data.orders[
                                this.state.salesOrderDetails.id
                              ].agent?.branch ? (
                                <List>
                                  <ListItem
                                    className="show-text"
                                    after="Branch Name"
                                  >
                                    <span slot="title">
                                      {
                                        this.props.data.orders[
                                          this.state.salesOrderDetails.id
                                        ].agent?.branch?.name
                                      }
                                    </span>
                                    <Icon f7="arrow_branch" slot="media" />
                                  </ListItem>
                                  <ListItem
                                    className="show-text"
                                    after="Branch Address"
                                  >
                                    <span slot="title">
                                      {
                                        this.props.data.orders[
                                          this.state.salesOrderDetails.id
                                        ].agent?.branch?.address
                                      }
                                    </span>
                                    <Icon f7="placemark_fill" slot="media" />
                                  </ListItem>
                                  <ListItem after="Branch Phone">
                                    <span slot="title">
                                      {
                                        this.props.data.orders[
                                          this.state.salesOrderDetails.id
                                        ].agent?.branch?.phone
                                      }
                                    </span>
                                    <Icon
                                      f7="phone_fill_arrow_up_right"
                                      slot="media"
                                    />
                                  </ListItem>
                                </List>
                              ) : null}
                            </List>
                          </CardContent>

                          <CardFooter>
                            <Button
                              outline
                              style={{
                                width: this.props.data.orders[
                                  this.state.salesOrderDetails.id
                                ].agent?.branch
                                  ? "30%"
                                  : "45%",
                              }}
                              href={`tel://${
                                this.props.data.delivery[
                                  this.props.data.orders[
                                    this.state.salesOrderDetails.id
                                  ].assignedAgentId
                                ].businessProfile.phone
                              }`}
                              external
                              onClick={() =>
                                this.$f7.methods.phoneCall(
                                  this.props.data.delivery[
                                    this.props.data.orders[
                                      this.state.salesOrderDetails.id
                                    ].assignedAgentId
                                  ].businessProfile.phone,
                                )
                              }
                            >
                              <Icon f7="phone_fill_arrow_up_right" />
                              &nbsp;&nbsp;&nbsp;Call Delivery Agent
                            </Button>

                            {this.props.data.orders[
                              this.state.salesOrderDetails.id
                            ].agent?.branch ? (
                              <Button
                                outline
                                style={{ width: "30%" }}
                                href={`tel://${
                                  this.props.data.orders[
                                    this.state.salesOrderDetails.id
                                  ].agent?.branch?.phone
                                }`}
                                external
                                onClick={() =>
                                  this.$f7.methods.phoneCall(
                                    this.props.data.orders[
                                      this.state.salesOrderDetails.id
                                    ].agent?.branch?.phone,
                                  )
                                }
                              >
                                <Icon f7="phone_fill_arrow_up_right" />
                                &nbsp;&nbsp;&nbsp;Call Delivery Branch
                              </Button>
                            ) : null}

                            <Button
                              outline
                              style={{
                                width: this.props.data.orders[
                                  this.state.salesOrderDetails.id
                                ].agent?.branch
                                  ? "30%"
                                  : "45%",
                              }}
                              onClick={() => this.$f7.methods.navMessage()}
                            >
                              <Icon f7="bubble_left_bubble_right" />
                              &nbsp;&nbsp;&nbsp;Chaw Message&#8482;
                            </Button>
                          </CardFooter>
                        </>
                      ) : (
                        <CardContent style={{ paddingTop: 0 }}>
                          <Block className="block-info">
                            <Row>
                              <Col>
                                <p>No Delivery Agent Details</p>
                              </Col>
                            </Row>
                          </Block>
                        </CardContent>
                      )}
                    </>
                  ) : (
                    <>
                      <CardHeader className="no-border">
                        Pickup Order
                      </CardHeader>
                      <CardContent style={{ paddingTop: 0 }}>
                        <Block className="block-info">
                          <Row>
                            <Col>
                              <p>
                                This package is designated for pickup from
                                merchant, no delivery details required.
                              </p>
                            </Col>
                          </Row>
                        </Block>
                      </CardContent>
                    </>
                  )}
                </Card>

                {/* [Card-6] User Issue Report */}
                {this.props.data.orders[this.state.salesOrderDetails.id]
                  .reportMerchant ? (
                  <Card
                    className="easyPrintText"
                    style={{ margin: "10pt auto" }}
                  >
                    <CardHeader className="no-border">
                      User Report
                      <Icon
                        f7="exclamationmark_triangle_fill"
                        style={{ color: "#E02020" }}
                      />
                    </CardHeader>
                    <CardContent>
                      <div
                        dangerouslySetInnerHTML={{
                          __html:
                            this.props.data.orders[
                              this.state.salesOrderDetails.id
                            ].reportMerchant.issue,
                        }}
                      ></div>
                    </CardContent>
                    <CardFooter>
                      <pre>
                        <small>
                          Reported:{" "}
                          {this.props.data.orders[
                            this.state.salesOrderDetails.id
                          ].reportMerchant.timestamp &&
                            moment(
                              this.props.data.orders[
                                this.state.salesOrderDetails.id
                              ].reportMerchant.timestamp,
                            ).format("dddd, MMMM Do, YYYY")}
                        </small>
                      </pre>
                    </CardFooter>
                  </Card>
                ) : null}

                {/* [Card-7] Delivery Agent Issue Report */}
                {this.props.data.orders[this.state.salesOrderDetails.id]
                  .issue ? (
                  <Card
                    className="easyPrintText"
                    style={{ margin: "10pt auto" }}
                  >
                    <CardHeader className="no-border">
                      Delivery Agent Report
                      <Icon
                        f7="exclamationmark_triangle_fill"
                        style={{ color: "#E02020" }}
                      />
                    </CardHeader>
                    <CardContent>
                      <div
                        dangerouslySetInnerHTML={{
                          __html:
                            this.props.data.orders[
                              this.state.salesOrderDetails.id
                            ].issue,
                        }}
                      ></div>
                    </CardContent>
                    <CardFooter>
                      <pre>
                        <small>
                          Reported:{" "}
                          {this.props.data.orders[
                            this.state.salesOrderDetails.id
                          ].issueTimestamp &&
                            moment(
                              this.props.data.orders[
                                this.state.salesOrderDetails.id
                              ].issueTimestamp,
                            ).format("dddd, MMMM Do, YYYY")}
                        </small>
                      </pre>
                    </CardFooter>
                  </Card>
                ) : null}

                {/* [Card-8] Admistrative Actions */}
                {(this.props.data.orders[this.state.salesOrderDetails.id]
                  .completed &&
                  this.props.data.orders[this.state.salesOrderDetails.id]
                    .orderStatus === "Order Completed") ||
                this.props.data.orders[this.state.salesOrderDetails.id]
                  .orderStatus === "Order Cancelled" ? null : (
                  <Card
                    style={{ margin: "10pt auto" }}
                    className="data-table data-table-init"
                  >
                    <CardHeader>
                      <div className="data-table-title">Admin Actions</div>
                    </CardHeader>
                    <CardContent padding={false}>
                      <table>
                        <thead>
                          <tr>
                            <th>
                              <span className="table-head-label">SNo.</span>
                            </th>
                            <th>
                              <span className="table-head-label">
                                Action Description
                              </span>
                            </th>
                            <th>
                              <span className="table-head-label">Action</span>
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {this.props.data.orders[
                            this.state.salesOrderDetails.id
                          ].orderStatus === "Order Pending" &&
                          this.props.data.orders[
                            this.state.salesOrderDetails.id
                          ].deliveryRequired &&
                          !this.props.data.orders[
                            this.state.salesOrderDetails.id
                          ].deliveryInclusive ? (
                            <tr>
                              <td>*</td>
                              <td>
                                <div>Assign delivery agent</div>
                              </td>
                              <td>
                                <Button
                                  fill
                                  onClick={async () => {
                                    await this.getNearestBranches();
                                    this.setState({
                                      ...this.state,
                                      vendorSheetOpened: true,
                                    });
                                  }}
                                >
                                  Delivery Agent
                                </Button>
                              </td>
                            </tr>
                          ) : null}

                          <tr>
                            <td>*</td>
                            <td>
                              <div>
                                Confirm order on behalf of{" "}
                                {this.props.data.orders[
                                  this.state.salesOrderDetails.id
                                ].deliveryRequired &&
                                this.props.data.orders[
                                  this.state.salesOrderDetails.id
                                ].orderStatus !== "Order Pending"
                                  ? "delivery agent"
                                  : "merchant"}
                              </div>
                            </td>
                            <td>
                              <Button
                                fill
                                className="button-fill-blue"
                                onClick={() =>
                                  this.confirmOrder(
                                    this.state.salesOrderDetails.id,
                                    this.state.salesOrderDetails
                                      .confirmationCode,
                                  )
                                }
                              >
                                Confirm Order
                              </Button>
                            </td>
                          </tr>

                          {this.props.data.orders[
                            this.state.salesOrderDetails.id
                          ].orderStatus === "Order Pending Confirmation" ||
                          this.props.data.orders[
                            this.state.salesOrderDetails.id
                          ].orderStatus === "Order Pending Delivery" ? (
                            <tr>
                              <td>*</td>
                              <td>
                                <div>
                                  Decline order on behalf of delivery agent
                                </div>
                              </td>
                              <td>
                                <Button
                                  fill
                                  className="button-fill-red"
                                  onClick={() =>
                                    this.declineOrderForDeliveryAgent(
                                      this.state.salesOrderDetails.id,
                                      `${
                                        this.props.data.orders[
                                          this.state.salesOrderDetails.id
                                        ].agent.name
                                      } ${
                                        this.props.data.orders[
                                          this.state.salesOrderDetails.id
                                        ].agent.branch?.name || ""
                                      }`,
                                    )
                                  }
                                >
                                  Decline Order
                                </Button>
                              </td>
                            </tr>
                          ) : null}

                          {this.props.data.orders[
                            this.state.salesOrderDetails.id
                          ].orderStatus === "Order Pending" ? (
                            <tr>
                              <td>*</td>
                              <td>
                                <div>Decline order on behalf of merchant</div>
                              </td>
                              <td>
                                <Button
                                  fill
                                  className="button-fill-red"
                                  onClick={() =>
                                    this.declineOrder(
                                      this.state.salesOrderDetails.id,
                                    )
                                  }
                                >
                                  Decline Order
                                </Button>
                              </td>
                            </tr>
                          ) : null}
                        </tbody>
                      </table>
                    </CardContent>
                  </Card>
                )}

                {/* [Sheet Modal] Delivery Agents Loader */}
                {this.state.vendorSheetOpened ? (
                  <div
                    style={{
                      margin: "auto",
                      width: "100%",
                      height: "400px",
                      position: "fixed",
                      left: 0,
                      bottom: 0,
                      backgroundColor: "#f3f3f3",
                      zIndex: "15",
                    }}
                  >
                    {/* Modal Navbar */}
                    <div
                      className="display-flex justify-content-space-between align-items-center"
                      style={{
                        width: "100%",
                        height: "40px",
                        color: "rgba(22, 22, 22, 0.8)",
                        backgroundColor: "#fed448",
                      }}
                    >
                      <div style={{ fontSize: "12px", marginLeft: "16px" }}>
                        <b>Assign Delivery Agent</b>
                      </div>
                      <div
                        style={{ fontSize: "10px", marginRight: "16px" }}
                        onClick={() => {
                          this.setState({
                            ...this.state,
                            nearestBranches: [],
                            vendorSheetOpened: false,
                            deliveryAgentName: "",
                            deliveryAgentEmail: "",
                          });
                        }}
                      >
                        Close
                      </div>
                    </div>

                    {/* Modal Content */}
                    <Card
                      className="data-table data-table-init"
                      style={{
                        marginLeft: "16px",
                        marginRight: "16px",
                      }}
                    >
                      <CardHeader
                        className="no-border"
                        style={{ paddingRight: 0 }}
                      >
                        <div className="data-table-title">Delivery Agents</div>

                        <div style={{ width: "50%" }}>
                          <List simpleList style={{ width: "100%" }}>
                            <ListItem>
                              <ListItemCell className="width-auto flex-shrink-0">
                                <Icon f7="car_fill"></Icon>
                              </ListItemCell>
                              <ListItemCell className="flex-shrink-3">
                                <Range
                                  value={this.state.deliveryAgentsRange}
                                  step={5}
                                  min={0}
                                  max={100}
                                  label={true}
                                  onRangeChange={(e) => {
                                    this.setState({
                                      ...this.state,
                                      deliveryAgentsRange: e,
                                    });
                                  }}
                                ></Range>
                              </ListItemCell>
                              <ListItemCell className="width-auto flex-shrink-0">
                                <h6>
                                  <span>{this.state.deliveryAgentsRange}</span>
                                  km
                                </h6>
                              </ListItemCell>
                            </ListItem>
                          </List>
                        </div>
                      </CardHeader>
                      <CardContent
                        padding={false}
                        style={{ width: "100%", maxHeight: "300px" }}
                      >
                        {/* find delivery agent within 15km */}
                        {this.props.ordered.delivery &&
                        this.state.deliveryAgents.filter(
                          (agent) =>
                            agent.currentStatus === "online" &&
                            agent.accountStatus === "Approved" &&
                            getDistance(
                              this.props.data.merchants[
                                this.state.salesOrderDetails.merchantId
                              ].businessProfile.geoLoc,
                              agent.businessProfile.geoLoc,
                            ) /
                              1000 <=
                              this.state.deliveryAgentsRange,
                        ).length > 0 ? (
                          <table className="sticky">
                            <thead>
                              <tr>
                                <th className="label-cell">Assign</th>

                                <th className="label-cell">
                                  Distance From Merchant
                                </th>

                                <th className="input-cell">
                                  <span className="table-head-label">
                                    Vendor Name
                                  </span>
                                  <div className="input">
                                    <input
                                      type="text"
                                      value={this.state.deliveryAgentName}
                                      onChange={(e) =>
                                        this.setState({
                                          ...this.state,
                                          deliveryAgentName: e.target.value,
                                          deliveryAgentEmail: "",
                                          filterBy: {
                                            dbName: "vendors",
                                            property: "name",
                                            value: e.target.value,
                                            type: "text",
                                          },
                                        })
                                      }
                                      placeholder="Filter"
                                    />
                                  </div>
                                </th>

                                <th className="input-cell">
                                  <span className="table-head-label">
                                    Vendor Email
                                  </span>
                                  <div className="input">
                                    <input
                                      type="email"
                                      value={this.state.deliveryAgentEmail}
                                      onChange={(e) =>
                                        this.setState({
                                          ...this.state,
                                          deliveryAgentName: "",
                                          deliveryAgentEmail: e.target.value,
                                          filterBy: {
                                            dbName: "vendors",
                                            property: "email",
                                            value: e.target.value,
                                            type: "text",
                                          },
                                        })
                                      }
                                      placeholder="Filter"
                                    />
                                  </div>
                                </th>

                                <th className="label-cell">Vendor Phone</th>

                                <th className="label-cell">Vendor Address</th>
                              </tr>
                            </thead>
                            <tbody>
                              {this.state.deliveryAgents
                                .filter(
                                  (agent) =>
                                    agent.currentStatus === "online" &&
                                    agent.accountStatus === "Approved" &&
                                    getDistance(
                                      this.props.data.merchants[
                                        this.state.salesOrderDetails.merchantId
                                      ].businessProfile.geoLoc,
                                      agent.businessProfile.geoLoc,
                                    ) /
                                      1000 <=
                                      this.state.deliveryAgentsRange,
                                )
                                .concat(this.state.nearestBranches)
                                .sort(
                                  (a, b) =>
                                    getDistance(
                                      this.props.data.merchants[
                                        this.state.salesOrderDetails.merchantId
                                      ].businessProfile.geoLoc,
                                      a.businessProfile?.geoLoc || a.geoLoc,
                                    ) /
                                      1000 -
                                    getDistance(
                                      this.props.data.merchants[
                                        this.state.salesOrderDetails.merchantId
                                      ].businessProfile.geoLoc,
                                      b.businessProfile?.geoLoc || b.geoLoc,
                                    ) /
                                      1000,
                                )
                                .map((agent) => (
                                  <tr key={agent.id}>
                                    <td>
                                      <Button
                                        fill
                                        className="button-fill-blue"
                                        onClick={() => {
                                          this.assignDeliveryAgent(
                                            this.state.salesOrderDetails.id,
                                            agent.id,
                                          );
                                        }}
                                      >
                                        Assign
                                      </Button>
                                    </td>
                                    <td>
                                      <div>
                                        {(
                                          getDistance(
                                            this.props.data.merchants[
                                              this.state.salesOrderDetails
                                                .merchantId
                                            ].businessProfile.geoLoc,
                                            agent.businessProfile?.geoLoc ||
                                              agent?.geoLoc,
                                          ) / 1000
                                        ).toFixed(2) + "km away"}
                                      </div>
                                    </td>
                                    <td>
                                      <div>
                                        {agent.businessProfile?.name ||
                                          `${agent.headquatersName} - ${agent.name}`}
                                      </div>
                                    </td>
                                    <td>
                                      <div>
                                        {agent.businessProfile?.email ||
                                          this.props.data.delivery[agent.HQId]
                                            ?.businessProfile?.email}
                                      </div>
                                    </td>
                                    <td>
                                      <div>
                                        {agent.businessProfile?.phone ||
                                          agent?.phone}
                                      </div>
                                    </td>
                                    <td>
                                      <div>
                                        {agent.businessProfile?.address ||
                                          agent?.address}
                                      </div>
                                    </td>
                                  </tr>
                                ))}
                            </tbody>
                          </table>
                        ) : (
                          <Block className="block-info">
                            <Row>
                              <Col>
                                <p>
                                  No Available delivery agent within{" "}
                                  {this.state.deliveryAgentsRange} km range of
                                  this merchant's location
                                </p>
                              </Col>
                            </Row>
                          </Block>
                        )}
                      </CardContent>
                    </Card>
                  </div>
                ) : null}
              </Block>
            ) : null}
          </Page>
        </Popup>
      </Page>
    );
  }

  //   Lifecycle
  static getDerivedStateFromProps(nextProps, prevState) {
    if (prevState.filterBy.dbName.trim() === "") {
      return {
        orders: (nextProps.ordered && nextProps.ordered.orders) || [],
        deliveryAgents: (nextProps.ordered && nextProps.ordered.delivery) || [],
      };
    } else {
      let modifiedState = {
        orders: (nextProps.ordered && nextProps.ordered.orders) || [],
        deliveryAgents: (nextProps.ordered && nextProps.ordered.delivery) || [],
      };

      switch (prevState.filterBy.dbName) {
        case "orders":
          let filter;
          switch (prevState.filterBy.type) {
            case "text":
              filter = new FilterByText(modifiedState.orders);
              return (modifiedState = {
                ...modifiedState,
                orders: filter.filter(prevState),
              });

            default:
          }
        case "vendors":
          switch (prevState.filterBy.type) {
            case "text":
              filter = new FilterByText(modifiedState.deliveryAgents);
              return (modifiedState = {
                ...modifiedState,
                deliveryAgents: filter.filter(prevState),
              });

            default:
          }

        default:
        // inbox
      }

      //   return modifiedState;
    }

    return null;
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.deliveryAgentsRange !== this.state.deliveryAgentsRange) {
      this.getNearestBranches();
    }
  }

  //   Events

  async getNearestBranches() {
    this.$f7.preloader.show();
    try {
      // Find cities within range

      const center = [
        this.props.data.merchants[this.state.salesOrderDetails.merchantId]
          .businessProfile.geoLoc.lat,
        this.props.data.merchants[this.state.salesOrderDetails.merchantId]
          .businessProfile.geoLoc.lng,
      ];
      const radiusInM = this.state.deliveryAgentsRange * 1000;

      // Each item in 'bounds' represents a startAt/endAt pair. We have to issue
      // a separate query for each pair. There can be up to 9 pairs of bounds
      // depending on overlap, but in most cases there are 4.
      const bounds = geofire.geohashQueryBounds(center, radiusInM);
      const promises = [];
      for (const b of bounds) {
        const q = this.props.firestore
          .collectionGroup("branches")
          .orderBy("geohash")
          .startAt(b[0])
          .endAt(b[1]);

        promises.push(q.get());
      }

      // Collect all the query results together into a single list
      Promise.all(promises).then((snapshots) => {
        const matchingDocs = [];

        for (const snap of snapshots) {
          for (const doc of snap.docs) {
            const lat = doc.get("geoLoc.lat");
            const lng = doc.get("geoLoc.lng");

            // We have to filter out a few false positives due to GeoHash
            // accuracy, but most will match
            const distanceInKm = geofire.distanceBetween([lat, lng], center);
            const distanceInM = distanceInKm * 1000;
            if (distanceInM <= radiusInM) {
              matchingDocs.push({
                HQId: doc.ref.parent.parent.id,
                id: doc.id,
                ...doc.data(),
              });
            }
          }
        }

        const formattedMatchingDocs = matchingDocs.filter(
          ({ HQId, suspended }) =>
            !suspended &&
            this.props.data?.delivery[HQId]?.accountStatus === "Approved",
        );

        this.setState({
          ...this.state,
          nearestBranches: formattedMatchingDocs,
        });
        this.$f7.preloader.hide();
      });
    } catch (error) {
      this.$f7.preloader.hide();
      console.log(error);
    }
  }

  datasetsSelector(sets) {
    switch (sets) {
      case 1:
        return [this.state.totalOrders];
      case 2:
        return [this.state.completedOrders];
      case 3:
        return [this.state.declinedOrders];
      // case 4:
      //   return [this.state.pendingOrders];
      // case 5:
      //   return [this.state.pendingDeliveryOrders];
      // case 6:
      //   return [this.state.pendingConfirmationOrders];
      case 4:
        return [
          this.state.totalOrders,
          // this.state.pendingOrders,
          // this.state.pendingDeliveryOrders,
          // this.state.pendingConfirmationOrders,
          this.state.completedOrders,
          this.state.declinedOrders,
        ];
      default:
        return [];
    }
  }

  switchDuration(e) {
    const duration = e.target.value;
    this.state = {
      ...this.state,
      duration
    }
    // this.setState(prevState => ({ ...this.prevState, duration: duration }));
    switch (duration) {
      case "1":
        this.displayDaily();
        break;
      case "2":
        this.displayWeekly();
        break;
      case "3":
        this.displayMonthly();
        break;
      case "4":
        this.displayYearly(Number(this.state.durationYearly));
        break;
      default:
        this.displayAllYears();
        break;
    }
  }

  switchDurationYearly(e) {
    const year = e.target.value;
    this.state = {
      ...this.state,
      durationYearly: Number(year)
    }
    this.displayYearly(Number(year));
  }

  displayDaily() {
    const labels = [moment().format("D MMM YYYY")];
    const todayOrders = this.props.ordered.orders.filter(
      (o) =>
        Number(moment(o.timestamp).format("YYYY")) ===
          Number(moment().format("YYYY")) &&
        Number(moment(o.timestamp).format("M")) ===
          Number(moment().format("M")) &&
        Number(moment(o.timestamp).format("D")) ===
          Number(moment().format("D")),
    );
    const totalOrders = {
      data: [],
    };
    // const pendingOrders = {
    //   data: [],
    // };
    // const pendingDeliveryOrders = {
    //   data: [],
    // };
    // const pendingConfirmationOrders = {
    //   data: [],
    // };
    const completedOrders = {
      data: [],
    };
    const declinedOrders = {
      data: [],
    };

    totalOrders.data.push(todayOrders.length);
    // pendingOrders.data.push(
    //   todayOrders.filter((o) => o.orderStatus === 'Order Pending').length
    // );
    // pendingDeliveryOrders.data.push(
    //   todayOrders.filter((o) => o.orderStatus === 'Order Pending Delivery')
    //     .length
    // );
    // pendingConfirmationOrders.data.push(
    //   todayOrders.filter((o) => o.orderStatus === 'Order Pending Confirmation')
    //     .length
    // );
    completedOrders.data.push(
      todayOrders.filter((o) => o.orderStatus === "Order Completed").length,
    );
    declinedOrders.data.push(
      todayOrders.filter((o) => o.orderStatus === "Order Cancelled").length,
    );

    this.setChartData(
      labels,
      totalOrders,
      // pendingOrders,
      // pendingDeliveryOrders,
      // pendingConfirmationOrders,
      completedOrders,
      declinedOrders,
    );
  }

  getMonthDaysAndData(
    startDay,
    orders,
    labels,
    totalOrders,
    // pendingOrders,
    // pendingDeliveryOrders,
    // pendingConfirmationOrders,
    completedOrders,
    declinedOrders,
    currentDayOfMonth,
  ) {
    if (startDay <= currentDayOfMonth) {
      labels.push(`${startDay}`);

      const currentDayTotalOrders = orders.filter(
        (o) => Number(moment(o.timestamp).format("D")) === startDay,
      );

      const currentDayCompletedOrders = currentDayTotalOrders.filter(
        (o) => o.orderStatus === "Order Completed",
      );

      // const currentDayPendigOrders = currentDayTotalOrders.filter(
      //   (o) => o.orderStatus === 'Order Pending'
      // );

      // const currentDayPendingDeliveryOrders = currentDayTotalOrders.filter(
      //   (o) => o.orderStatus === 'Order Pending Delivery'
      // );

      // const currentDayPendingConfirmationOrders = currentDayTotalOrders.filter(
      //   (o) => o.orderStatus === 'Order Pending Confirmation'
      // );

      const currentDayDeclineddOrders = currentDayTotalOrders.filter(
        (o) => o.orderStatus === "Order Cancelled",
      );

      totalOrders.data.push(currentDayTotalOrders.length);

      // pendingOrders.data.push(currentDayPendigOrders.length);

      // pendingDeliveryOrders.data.push(currentDayPendingDeliveryOrders.length);

      // pendingConfirmationOrders.data.push(
      //   currentDayPendingConfirmationOrders.length
      // );

      completedOrders.data.push(currentDayCompletedOrders.length);

      declinedOrders.data.push(currentDayDeclineddOrders.length);

      this.getMonthDaysAndData(
        startDay + 1,
        orders,
        labels,
        totalOrders,
        // pendingOrders,
        // pendingDeliveryOrders,
        // pendingConfirmationOrders,
        completedOrders,
        declinedOrders,
        currentDayOfMonth,
      );
    }
  }

  displayMonthly() {
    const currentDayOfTheMonth = Number(moment().format("D"));
    const ordersForCurrentMonth = this.props.ordered.orders.filter(
      (o) =>
        Number(moment(o.timestamp).format("YYYY")) ===
          Number(moment().format("YYYY")) &&
        Number(moment(o.timestamp).format("M")) ===
          Number(moment().format("M")),
    );

    const labels = [];
    const totalOrders = {
      data: [],
    };
    // const pendingOrders = {
    //   data: [],
    // };
    // const pendingDeliveryOrders = {
    //   data: [],
    // };
    // const pendingConfirmationOrders = {
    //   data: [],
    // };
    const completedOrders = {
      data: [],
    };
    const declinedOrders = {
      data: [],
    };

    this.getMonthDaysAndData(
      1,
      ordersForCurrentMonth,
      labels,
      totalOrders,
      // pendingOrders,
      // pendingDeliveryOrders,
      // pendingConfirmationOrders,
      completedOrders,
      declinedOrders,
      currentDayOfTheMonth,
    );

    this.setChartData(
      labels,
      totalOrders,
      // pendingOrders,
      // pendingDeliveryOrders,
      // pendingConfirmationOrders,
      completedOrders,
      declinedOrders,
    );
  }

  getWeekDays(currentDay, arr, d, total) {
    if (total >= 0) {
      if (currentDay < 0) {
        arr.unshift(d[currentDay + 7]);
      } else {
        arr.unshift(d[currentDay]);
      }

      this.getWeekDays(currentDay - 1, arr, d, total - 1);
    }
  }

  setWeekDaysData(
    weekOrders,
    totalOrders,
    // pendingOrders,
    // pendingDeliveryOrders,
    // pendingConfirmationOrders,
    completedOrders,
    declinedOrders,
    i,
  ) {
    const currentDayTotalOrders = weekOrders.filter(
      (o) => Number(moment(o.timestamp).format("d")) === i,
    );

    // const currentDayPendingOrders = currentDayTotalOrders.filter(
    //   (o) => o.orderStatus === 'Order Pending'
    // );

    // const currentDayPendingDeliveryOrders = currentDayTotalOrders.filter(
    //   (o) => o.orderStatus === 'Order Pending Delivery'
    // );

    // const currentDayPendingConfirmationOrders = currentDayTotalOrders.filter(
    //   (o) => o.orderStatus === 'Order Pending Confirmation'
    // );

    const currentDayCompletedOrders = currentDayTotalOrders.filter(
      (o) => o.orderStatus === "Order Completed",
    );

    const currentDayDeclineddOrders = currentDayTotalOrders.filter(
      (o) => o.orderStatus === "Order Cancelled",
    );

    totalOrders.data.unshift(currentDayTotalOrders.length);

    // pendingOrders.data.unshift(currentDayPendingOrders.length);

    // pendingDeliveryOrders.data.unshift(currentDayPendingDeliveryOrders.length);

    // pendingConfirmationOrders.data.unshift(
    //   currentDayPendingConfirmationOrders.length
    // );

    completedOrders.data.unshift(currentDayCompletedOrders.length);

    declinedOrders.data.unshift(currentDayDeclineddOrders.length);
  }

  getWeekDaysData(
    currentDay,
    weekOrders,
    totalOrders,
    // pendingOrders,
    // pendingDeliveryOrders,
    // pendingConfirmationOrders,
    completedOrders,
    declinedOrders,
    total,
  ) {
    if (total >= 0) {
      if (currentDay < 0) {
        this.setWeekDaysData(
          weekOrders,
          totalOrders,
          // pendingOrders,
          // pendingDeliveryOrders,
          // pendingConfirmationOrders,
          completedOrders,
          declinedOrders,
          currentDay + 7,
        );
      } else {
        this.setWeekDaysData(
          weekOrders,
          totalOrders,
          // pendingOrders,
          // pendingDeliveryOrders,
          // pendingConfirmationOrders,
          completedOrders,
          declinedOrders,
          currentDay,
        );
      }

      this.getWeekDaysData(
        currentDay - 1,
        weekOrders,
        totalOrders,
        // pendingOrders,
        // pendingDeliveryOrders,
        // pendingConfirmationOrders,
        completedOrders,
        declinedOrders,
        total - 1,
      );
    }
  }

  displayWeekly() {
    const days = {
      0: "Sun",
      1: "Mon",
      2: "Tue",
      3: "Wed",
      4: "Thu",
      5: "Fri",
      6: "Sat",
    };

    const currentDayOfTheWeek = Number(moment().format("d"));
    const labels = [];
    const totalOrders = {
      data: [],
    };
    // const pendingOrders = {
    //   data: [],
    // };
    // const pendingDeliveryOrders = {
    //   data: [],
    // };
    // const pendingConfirmationOrders = {
    //   data: [],
    // };
    const completedOrders = {
      data: [],
    };
    const declinedOrders = {
      data: [],
    };

    const currentWeekOrders = this.props.ordered.orders
      .filter(
        (o) =>
          Number(moment().diff(moment(o.timestamp), "days")) >= 0 &&
          Number(moment().diff(moment(o.timestamp), "days")) <= 6 &&
          // Number(moment(o.timestamp).format('M')) ===
          //   Number(moment().format('M')) &&
          Number(moment(o.timestamp).format("YYYY")) ===
            Number(moment().format("YYYY")),
      )
      .filter((o) => {
        if (Number(moment().diff(moment(o.timestamp), "days")) === 6) {
          if (+moment().format("D") === +moment(o.timestamp).format("D")) {
            return true;
          } else {
            return false;
          }
        } else {
          return true;
        }
      });

    this.getWeekDays(currentDayOfTheWeek, labels, days, 6);
    this.getWeekDaysData(
      currentDayOfTheWeek,
      currentWeekOrders,
      totalOrders,
      // pendingOrders,
      // pendingDeliveryOrders,
      // pendingConfirmationOrders,
      completedOrders,
      declinedOrders,
      6,
    );

    this.setChartData(
      labels,
      totalOrders,
      // pendingOrders,
      // pendingDeliveryOrders,
      // pendingConfirmationOrders,
      completedOrders,
      declinedOrders,
    );
  }

  getYearlyData(
    startMonth,
    months,
    year,
    orders,
    labels,
    totalOrders,
    // pendingOrders,
    // pendingDeliveryOrders,
    // pendingConfirmationOrders,
    completedOrders,
    declinedOrders,
    currentMonth,
  ) {
    if (startMonth <= currentMonth) {
      labels.push(months[startMonth]);
      const currentMonthOrders = orders.filter(
        (o) =>
          parseInt(moment(o.timestamp).format("M")) === startMonth &&
          Number(moment(o.timestamp).format("YYYY")) === year,
      );

      const currentMonthCompletedOrders = currentMonthOrders.filter(
        (o) => o.orderStatus === "Order Completed",
      );

      const currentMonthDeclinedOrders = currentMonthOrders.filter(
        (o) => o.orderStatus === "Order Cancelled",
      );

      // const currentMonthPendingOrders = currentMonthOrders.filter(
      //   (o) => o.orderStatus === 'Order Pending'
      // );

      // const currentMonthPendingDeliveryOrders = currentMonthOrders.filter(
      //   (o) => o.orderStatus === 'Order Pending Delivery'
      // );

      // const currentMonthPendingConfirmationOrders = currentMonthOrders.filter(
      //   (o) => o.orderStatus === 'Order Pending Confirmation'
      // );

      totalOrders.data.push(currentMonthOrders.length);

      // pendingOrders.data.push(currentMonthPendingOrders.length);

      // pendingDeliveryOrders.data.push(currentMonthPendingDeliveryOrders.length);

      // pendingConfirmationOrders.data.push(
      //   currentMonthPendingConfirmationOrders.length
      // );

      completedOrders.data.push(currentMonthCompletedOrders.length);

      declinedOrders.data.push(currentMonthDeclinedOrders.length);

      this.getYearlyData(
        startMonth + 1,
        months,
        year,
        orders,
        labels,
        totalOrders,
        // pendingOrders,
        // pendingDeliveryOrders,
        // pendingConfirmationOrders,
        completedOrders,
        declinedOrders,
        currentMonth,
      );
    }
  }

  displayYearly(year = Number(moment().format("YYYY"))) {
    const months = {
      1: "Jan",
      2: "Feb",
      3: "Mar",
      4: "Apr",
      5: "May",
      6: "Jun",
      7: "Jul",
      8: "Aug",
      9: "Sep",
      10: "Oct",
      11: "Nov",
      12: "Dec",
    };
    const labels = [];
    const currentMonth = year === Number(moment().format("YYYY")) ? moment().format("M") : "12";
    const totalOrders = {
      data: [],
    };
    // const pendingOrders = {
    //   data: [],
    // };
    // const pendingDeliveryOrders = {
    //   data: [],
    // };
    // const pendingConfirmationOrders = {
    //   data: [],
    // };
    const completedOrders = {
      data: [],
    };
    const declinedOrders = {
      data: [],
    };

    this.getYearlyData(
      1,
      months,
      year,
      this.props.ordered.orders,
      labels,
      totalOrders,
      // pendingOrders,
      // pendingDeliveryOrders,
      // pendingConfirmationOrders,
      completedOrders,
      declinedOrders,
      currentMonth,
    );

    this.setChartData(
      labels,
      totalOrders,
      // pendingOrders,
      // pendingDeliveryOrders,
      // pendingConfirmationOrders,
      completedOrders,
      declinedOrders,
    );
  }

  getAllYearsData( 
    startYear,
    orders,
    labels,
    totalOrders,
    // pendingOrders,
    // pendingDeliveryOrders,
    // pendingConfirmationOrders,
    completedOrders,
    declinedOrders,
) {
  if (startYear <= Number(moment().format("YYYY"))) {
    labels.push(`${startYear}`);
    const currentYearOrders = orders.filter(
      (o) => Number(moment(o.timestamp).format("YYYY")) === startYear
    );

    const currentYearCompletedOrders = currentYearOrders.filter(
      (o) => o.orderStatus === "Order Completed",
    );

    const currentYearDeclinedOrders = currentYearOrders.filter(
      (o) => o.orderStatus === "Order Cancelled",
    );

    // const currentMonthPendingOrders = currentMonthOrders.filter(
    //   (o) => o.orderStatus === 'Order Pending'
    // );

    // const currentMonthPendingDeliveryOrders = currentMonthOrders.filter(
    //   (o) => o.orderStatus === 'Order Pending Delivery'
    // );

    // const currentMonthPendingConfirmationOrders = currentMonthOrders.filter(
    //   (o) => o.orderStatus === 'Order Pending Confirmation'
    // );

    totalOrders.data.push(currentYearOrders.length);

    // pendingOrders.data.push(currentMonthPendingOrders.length);

    // pendingDeliveryOrders.data.push(currentMonthPendingDeliveryOrders.length);

    // pendingConfirmationOrders.data.push(
    //   currentMonthPendingConfirmationOrders.length
    // );

    completedOrders.data.push(currentYearCompletedOrders.length);

    declinedOrders.data.push(currentYearDeclinedOrders.length);

    this.getAllYearsData(
      startYear + 1,
      orders,
      labels,
      totalOrders,
      // pendingOrders,
      // pendingDeliveryOrders,
      // pendingConfirmationOrders,
      completedOrders,
      declinedOrders,
    );
  }
}
  displayAllYears() {
    const labels = [];
    const totalOrders = {
      data: [],
    };
    // const pendingOrders = {
    //   data: [],
    // };
    // const pendingDeliveryOrders = {
    //   data: [],
    // };
    // const pendingConfirmationOrders = {
    //   data: [],
    // };
    const completedOrders = {
      data: [],
    };
    const declinedOrders = {
      data: [],
    };

    this.getAllYearsData(
      2019,
      this.props.ordered.orders,
      labels,
      totalOrders,
      // pendingOrders,
      // pendingDeliveryOrders,
      // pendingConfirmationOrders,
      completedOrders,
      declinedOrders,
    );

    this.setChartData(
      labels,
      totalOrders,
      // pendingOrders,
      // pendingDeliveryOrders,
      // pendingConfirmationOrders,
      completedOrders,
      declinedOrders,
    );
  }

  setChartData(
    labels,
    totalOrders,
    // pendingOrders,
    // pendingDeliveryOrders,
    // pendingConfirmationOrders,
    completedOrders,
    declinedOrders,
  ) {
    totalOrders.backgroundColor = Array(totalOrders.data.length).fill(
      "rgba(135, 206, 235, 0.7)",
    );
    // pendingOrders.backgroundColor = Array(pendingOrders.data.length).fill(
    //   'rgba(250, 144, 40, 0.7)'
    // );
    // pendingDeliveryOrders.backgroundColor = Array(
    //   pendingDeliveryOrders.data.length
    // ).fill('rgba(217, 87, 250, 0.7)');
    // pendingConfirmationOrders.backgroundColor = Array(
    //   pendingConfirmationOrders.data.length
    // ).fill('rgba(68, 158, 227, 0.7)');
    completedOrders.backgroundColor = Array(completedOrders.data.length).fill(
      "rgba(75, 192, 192, 0.7)",
    );
    declinedOrders.backgroundColor = Array(declinedOrders.data.length).fill(
      "rgba(255, 99, 132, 0.7)",
    );

    this.setState({
      ...this.state,
      labels,
      totalOrders: {
        ...this.state.totalOrders,
        ...totalOrders,
      },
      // pendingOrders: {
      //   ...this.state.pendingOrders,
      //   ...pendingOrders,
      // },
      // pendingDeliveryOrders: {
      //   ...this.state.pendingDeliveryOrders,
      //   ...pendingDeliveryOrders,
      // },
      // pendingConfirmationOrders: {
      //   ...this.state.pendingConfirmationOrders,
      //   ...pendingConfirmationOrders,
      // },
      completedOrders: {
        ...this.state.completedOrders,
        ...completedOrders,
      },
      declinedOrders: {
        ...this.state.declinedOrders,
        ...declinedOrders,
      },
    });
  }

  declineOrderForDeliveryAgent(orderId, deliveryAgentName) {
    let self = this;
    let app = self.$f7;
    app.dialog
      .create({
        title: "Decline Order",
        cssClass: "otp-code-modal",
        text: `Are you sure u want to decline this order on behalf of ${deliveryAgentName} to be reassigned to another agent?`,
        destroyOnClose: true,
        buttons: [
          // button to close modal
          {
            text: "x",
            color: "white",
            cssClass: "otp-close",
          },
          // button to continue
          {
            text: "Yes",
            bold: true,
            cssClass: "otp-continue button button-fill-red",
            keyCodes: [13],
            close: false,
            onClick: (dialog, e) => {
              app.preloader.show();
              this.props.firestore
                .collection("orders")
                .doc(orderId)
                .update({
                  assignedAgentId: "",
                  agent: {},
                  triggeredBy: this.props.auth.uid,
                  orderStatus: "Order Pending",
                  assignedByAdminOrSupport: null,
                  deliveryDeclinedByAdminOrSupport: {
                    name: this.props.profile.fullName,
                    email: this.props.profile.email,
                    role: this.props.profile.role,
                    phone: this.props.profile.phoneNumber,
                    timestamp: Date.now(),
                    deliveryAgentName,
                  },
                })
                .then(() => {
                  this.setState({
                    ...this.state,
                    vendorSheetOpened: false,
                    deliveryAgentName: "",
                    deliveryAgentEmail: "",
                  });
                  app.preloader.hide();

                  toast(app.toast, {
                    text: "Order delivery declined",
                    position: "bottom",
                    horizontalPosition: "center",
                    closeButton: true,
                    cssClass: "custom-toast",
                    closeTimeout: 4000,
                  });
                  dialog.close();
                })
                .catch((error) => {
                  this.setState({
                    ...this.state,
                    vendorSheetOpened: false,
                    deliveryAgentName: "",
                    deliveryAgentEmail: "",
                  });
                  this.$f7.preloader.hide();
                  toast(app.toast, {
                    text: handleErrors(error),
                    position: "bottom",
                    horizontalPosition: "center",
                    closeButton: true,
                    cssClass: "custom-toast",
                    closeTimeout: 4000,
                  });
                  dialog.close();
                });
            },
          },
        ],
      })
      .open();
  }

  assignDeliveryAgent(orderId, assignedAgentId) {
    let self = this;
    let app = self.$f7;
    app.dialog
      .create({
        title: "Assign Delivery Agent",
        cssClass: "otp-code-modal",
        text: `Assign Order: ${orderId} to delivery agent ${
          this.props.data.delivery[assignedAgentId]?.businessProfile.name ||
          this.state.nearestBranches.find(({ id }) => id === assignedAgentId)
            .name
        }`,
        destroyOnClose: true,
        buttons: [
          // button to close modal
          {
            text: "x",
            color: "white",
            cssClass: "otp-close",
          },
          // button to continue
          {
            text: "Assign",
            bold: true,
            cssClass: "otp-continue button button-fill-red",
            keyCodes: [13],
            close: false,
            onClick: (dialog, e) => {
              app.preloader.show();

              const branch = this.state.nearestBranches.find(
                ({ id }) => id === assignedAgentId,
              );

              assignedAgentId = branch ? branch.HQId : assignedAgentId;

              const isBranch = branch ? true : false;

              const agent = {
                name: this.props.data.delivery[assignedAgentId].businessProfile
                  .name,
                address:
                  this.props.data.delivery[assignedAgentId].businessProfile
                    .address,
                phone:
                  this.props.data.delivery[assignedAgentId].businessProfile
                    .phone,

                branch: isBranch
                  ? {
                      id: branch.id,
                      name: branch.name,
                      address: branch.address,
                      phone: branch.phone,
                    }
                  : null,
              };

              this.props.firestore
                .collection("orders")
                .doc(orderId)
                .update({
                  assignedAgentId,
                  agent,
                  orderStatus: "Order Pending Delivery",
                  assignedByAdminOrSupport: {
                    name: this.props.profile.fullName,
                    email: this.props.profile.email,
                    role: this.props.profile.role,
                    phone: this.props.profile.phoneNumber,
                    timestamp: Date.now(),
                  },
                })
                .then(() => {
                  this.setState({
                    ...this.state,
                    vendorSheetOpened: false,
                    deliveryAgentName: "",
                    deliveryAgentEmail: "",
                    nearestBranches: [],
                    vendorSheetOpened: false,
                    deliveryAgentName: "",
                    deliveryAgentEmail: "",
                  });
                  app.preloader.hide();

                  toast(app.toast, {
                    text: "Order has been assigned",
                    position: "bottom",
                    horizontalPosition: "center",
                    closeButton: true,
                    cssClass: "custom-toast",
                    closeTimeout: 4000,
                  });
                  dialog.close();
                })
                .catch((error) => {
                  this.setState({
                    ...this.state,
                    vendorSheetOpened: false,
                    deliveryAgentName: "",
                    deliveryAgentEmail: "",
                    nearestBranches: [],
                    vendorSheetOpened: false,
                    deliveryAgentName: "",
                    deliveryAgentEmail: "",
                  });
                  this.$f7.preloader.hide();
                  toast(app.toast, {
                    text: handleErrors(error),
                    position: "bottom",
                    horizontalPosition: "center",
                    closeButton: true,
                    cssClass: "custom-toast",
                    closeTimeout: 4000,
                  });
                  dialog.close();
                });
            },
          },
        ],
      })
      .open();
  }

  confirmOrder(orderId, confirmationCode) {
    this.$f7.dialog
      .create({
        title: "Confirmation Code",
        cssClass: "otp-code-modal",
        text: "Please enter order cofirmation code to confirm this order.",
        content: `<input class="dialog-input single-input" type="text" maxlength="6"/>`,
        destroyOnClose: true,
        buttons: [
          // button to cancel
          {
            text: "x",
            color: "white",
            cssClass: "otp-close",
          },
          // button to continue
          {
            text: "Confirm Order",
            bold: true,
            cssClass: "otp-continue",
            keyCodes: [13],
            close: false,
            onClick: (dialog, e) => {
              this.$f7.preloader.show();
              if (confirmationCode.trim() === "") {
                this.$f7.preloader.hide();
                return toast(this.$f7.toast, {
                  text: "Please enter the confirmation code for this order",
                  position: "bottom",
                  horizontalPosition: "center",
                  closeButton: true,
                  cssClass: "custom-toast",
                  closeTimeout: 4000,
                });
              }

              const inputedCode = dialog.$el.find(".dialog-input").val();
              if (confirmationCode === inputedCode) {
                // send confirmation mail
                dialog.close();
                this.$f7.preloader.show();
                // send otp mail
                this.props.firebase
                  .auth()
                  .currentUser.getIdToken(true)
                  .then((idToken) => {
                    // send OTP to Easychaw's email
                    sendEasychawOneTimePassword(
                      {
                        token: idToken,
                        uid: this.props.auth.uid,
                        actions: "Confirmation",
                      },
                      (error, sent) => {
                        if (error || !sent) {
                          this.$f7.preloader.hide();
                          return toast(this.$f7.toast, {
                            text: error,
                            position: "bottom",
                            horizontalPosition: "center",
                            closeButton: true,
                            cssClass: "custom-toast",
                            closeTimeout: 4000,
                          });
                        }

                        // open a dialog to confirm OTP
                        this.$f7.preloader.hide();
                        this.$f7.dialog
                          .create({
                            title: "OTP CODE",
                            cssClass: "otp-code-modal",
                            text: "Confirm changes by filling in the OTP code sent to Easychaw's email address",
                            content: `<input class="dialog-input split-input" type="password" maxlength="4" />`,
                            buttons: [
                              // button to resend otp
                              {
                                text: "Resend Code",
                                color: "gray",
                                cssClass: "otp-resend",

                                close: false,
                                onClick: (dialog, e) => {
                                  this.$f7.preloader.show();
                                  sendEasychawOneTimePassword(
                                    {
                                      token: idToken,
                                      uid: this.props.auth.uid,
                                      actions: "Confirmation",
                                    },
                                    (error, sent) => {
                                      if (error || !sent) {
                                        this.$f7.preloader.hide();
                                        return toast(this.$f7.toast, {
                                          text: error,
                                          position: "bottom",
                                          horizontalPosition: "center",
                                          closeButton: true,
                                          cssClass: "custom-toast",
                                          closeTimeout: 4000,
                                        });
                                      }

                                      this.$f7.preloader.hide();
                                      return toast(this.$f7.toast, {
                                        text: "OTP code sent",
                                        position: "bottom",
                                        horizontalPosition: "center",
                                        closeButton: true,
                                        cssClass: "custom-toast",
                                        closeTimeout: 4000,
                                      });
                                    },
                                  );
                                },
                              },
                              // button to cancel
                              {
                                text: "x",
                                color: "white",
                                cssClass: "otp-close",
                                onClick: (dialog, e) => {
                                  this.$f7.preloader.hide();
                                },
                              },
                              // button to continue
                              {
                                text: "Continue",
                                bold: true,
                                cssClass: "otp-continue",
                                keyCodes: [13],
                                close: false,
                                onClick: (cdialog, e) => {
                                  this.$f7.preloader.show();
                                  // password
                                  const password = cdialog.$el
                                    .find(".dialog-input")
                                    .val();

                                  // Verify otp
                                  verifyEasychawOneTimePassword(
                                    {
                                      password,
                                      token: idToken,
                                      uid: this.props.auth.uid,
                                    },
                                    (error, success) => {
                                      if (error || !success) {
                                        this.$f7.preloader.hide();
                                        return toast(this.$f7.toast, {
                                          text: error,
                                          position: "bottom",
                                          horizontalPosition: "center",
                                          closeButton: true,
                                          cssClass: "custom-toast",
                                          closeTimeout: 4000,
                                        });
                                      }

                                      // close dialog
                                      cdialog.close();

                                      this.props.firestore
                                        .collection("orders")
                                        .doc(orderId)
                                        .update({
                                          orderStatus: "Order Completed",
                                          completed: true,
                                          triggeredBy: this.props.auth.uid,
                                          confirmedByAdminOrSupport: {
                                            name: this.props.profile.fullName,
                                            email: this.props.profile.email,
                                            role: this.props.profile.role,
                                            phone:
                                              this.props.profile.phoneNumber,
                                            timestamp: Date.now(),
                                          },
                                        })
                                        .then(() => {
                                          this.$f7.preloader.hide();
                                          toast(this.$f7.toast, {
                                            text: "Order Confirmed",
                                            position: "bottom",
                                            horizontalPosition: "center",
                                            closeButton: true,
                                            cssClass: "custom-toast",
                                            closeTimeout: 4000,
                                          });
                                        })
                                        .catch((error) => {
                                          this.$f7.preloader.hide();
                                          toast(this.$f7.toast, {
                                            text: handleErrors(error),
                                            position: "bottom",
                                            horizontalPosition: "center",
                                            closeButton: true,
                                            cssClass: "custom-toast",
                                            closeTimeout: 4000,
                                          });
                                        });
                                    },
                                  );
                                },
                              },
                            ],
                          })
                          .open();
                      },
                    );
                  })
                  .catch((error) => {
                    this.$f7.preloader.hide();
                    return toast(this.$f7.toast, {
                      text: handleErrors(error),
                      position: "bottom",
                      horizontalPosition: "center",
                      closeButton: true,
                      cssClass: "custom-toast",
                      closeTimeout: 4000,
                    });
                  });
              } else {
                this.$f7.preloader.hide();
                toast(this.$f7.toast, {
                  text: "Delivery not confirmed",
                  position: "bottom",
                  horizontalPosition: "center",
                  closeButton: true,
                  cssClass: "custom-toast",
                  closeTimeout: 4000,
                });
                dialog.close();
              }
            },
          },
        ],
      })
      .open();
  }

  declineOrder(orderId) {
    const self = this;
    const app = self.$f7;
    app.dialog
      .create({
        title: "Decline Order",
        cssClass: "otp-code-modal",
        text: "This action is irreversible, order will be cancelled and funds returned to user wallet",
        destroyOnClose: true,
        buttons: [
          // button to close modal
          {
            text: "x",
            color: "white",
            cssClass: "otp-close",
          },
          // button to continue
          {
            text: "Decline Order",
            bold: true,
            cssClass: "otp-continue button button-fill-red",
            keyCodes: [13],
            close: false,
            onClick: (dialog, e) => {
              app.preloader.show();
              // Update order status
              self.props.firestore
                .collection("orders")
                .doc(orderId)
                .update({
                  orderStatus: "Order Cancelled",
                  cancelledByAdminOrSupport: {
                    name: this.props.profile.fullName,
                    email: this.props.profile.email,
                    role: this.props.profile.role,
                    phone: this.props.profile.phoneNumber,
                    timestamp: Date.now(),
                  },
                })
                .then(() => {
                  app.preloader.hide();
                  toast(app.toast, {
                    text: "Order Cancelled",
                    position: "bottom",
                    horizontalPosition: "center",
                    closeButton: true,
                    cssClass: "custom-toast",
                    closeTimeout: 4000,
                  });
                  dialog.close();
                })
                .catch((error) => {
                  app.preloader.hide();
                  toast(app.toast, {
                    text: handleErrors(error),
                    position: "bottom",
                    horizontalPosition: "center",
                    closeButton: true,
                    cssClass: "custom-toast",
                    closeTimeout: 4000,
                  });
                  dialog.close();
                });
            },
          },
        ],
      })
      .open();
  }
}

const mapStateToProps = ({
  firebase: { auth, profile },
  DB: { data, ordered },
}) => ({
  auth,
  profile,
  data,
  ordered,
});

const enhance = compose(
  withFirestore,
  firestoreConnect([
    new Collections("merchants"),
    new Collections("delivery"),
    new Collections("orders"),
  ]),
  connect(mapStateToProps),
);

export default enhance(AdminSales);
